export default __webpack_public_path__ + "static/media/login-logo.a3bfd532.png";